import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { Label, Glyphicon, Text } from 'reaxl';
import { BrowserStorage } from '@atc/browser-storage';
import formatDateToMMYY from '../utilities/formatDateToMMDD';

const lastSyncCache = /* #__PURE__*/ new BrowserStorage('LAST_WALLET_SYNC', {
    persist: true,
});

function SyncMyWalletAlert({ success, className, uiContext = 'default' } = {}) {
    if (uiContext === 'default') {
        return (
            <Label
                data-cmp="wallet-sync-alert"
                className={clsx('margin-bottom-0 display-inline-flex align-items-baseline', className)}
                bsStyle={success ? 'secondary' : 'danger'}
            >
                <Glyphicon
                    glyph={success ? 'success' : 'danger'}
                    className={clsx('margin-right-2', success && 'text-success')}
                />
                {success ? 'Settings Updated!' : 'Import Unsuccessful. Try Again.'}
            </Label>
        );
    }

    const lastDateSync = lastSyncCache.getItem();

    const syncDate = lastDateSync ? new Date(lastDateSync) : new Date();

    const formattedDate = formatDateToMMYY(syncDate);

    return (
        <Text
            color={`${success ? 'success' : 'danger'}`}
            componentClass="div"
            size={200}
        >
            {success ? `Synced ${formattedDate}` : 'Import Unsuccessful. Try Again.'}
        </Text>
    );
}

SyncMyWalletAlert.propTypes /* remove-proptypes */ = {
    /**
     * The className to apply to the root node
     */
    className: PropTypes.string,
    /**
     * success for displaying messages
     */
    success: PropTypes.bool,
    /**
     * uiContext for displaying different type of alert
     */
    uiContext: PropTypes.string,
};

export default SyncMyWalletAlert;
